<template>
  <n-page-header class="mb-2">
    <template #header>
      <AragBreadcrumb />
    </template>
  </n-page-header>
</template>

<script setup lang="ts">
import AragBreadcrumb from '@/components/AragBreadcrumb.vue'

import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

const pageTitle = computed(() => {
  return route.meta.breadcrumb || 'Seitenüberschrift'
})
</script>
